/* eslint-disable max-len */
import React from "react";
import Button from "../../../components/Button";

export default function Confirmationpopup({ message, Title, handleSubmit, loading, handleClick, handleClose, stateKey, contentText }) {
    
    return (
        <div className="p-6 w-full bg-white">
            <div className="flex pb-4 justify-between">
                <h1 className="text-lg font-normla text-[#1f1f1f]">
                    {Title}
                </h1>
                {/* <img src="../../src/assets/images/close-icon.svg" alt="" /> */}
            </div>
            {/* {contentText && contentText} */}
            {contentText && (<p>{contentText}</p>)}
            {/* <p className="text-sm font-normal text-[#4B4B4B]">The deactivation of this store will result in deactivation of all employees associated with it.</p> */}
            <p className="text-sm font-normal text-[#4B4B4B]">
                {message}
            </p>
            <div className="flex justify-end space-x-2 mt-6">
                <button className="px-4 py-[10px] rounded-[12px] text-primary" onClick={()=>handleClose()} data-testid="cancel-btn">Cancel</button>
                <>
                    <Button
                        handleClick={handleSubmit}
                        loading={loading}
                        disabled={loading}
                        text={Title.split(' ')[0]}
                        classKey="px-4 py-[10px] bg-primary text-white rounded-[12px]"
                        type="submit"
                        testId="confirm-btn"
                
                    /></>
            </div>
        </div>
    );
}
